import { networkClient } from '@network/networkClient'
import { getGlobalParams } from '../globalParams'
import {
  GET_CURRENT_JACKPOT_FOR_BRAND,
  GET_CURRENT_JACKPOT_FOR_BRAND_USER_SPECIFIC,
  GET_USER_ALL_TICKETS_FOR_JACKPOT,
  GET_TOP_CURRENT_JACKPOT_CONTRIBUTIONS,
  GET_PRIZE_DISTRIBUTION_DETAILS_FOR_JACKPOT,
  GET_USER_CONTRIBUTIONS_FOR_JACKPOT,
  GET_USER_JACKPOT_HISTORY,
  GET_USER_JACKPOT_HISTORY_RESULTS,
} from '../queries/jackpotQueries'
import { logger } from '@logger'

const MODULE = 'Jackpot Service'

export const getCurrentJackpotForBrand = async () => {
  const { operatorId, brandId, currency, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_CURRENT_JACKPOT_FOR_BRAND,
      variables: { operatorId, brandId, currency, gameCode },
    },
  })

  logger.info(MODULE, 'getCurrentJackpotForBrand Response', response)

  if (response.jackpot.getCurrentJackpotForBrand.success) {
    return response.jackpot.getCurrentJackpotForBrand.data
  } else {
    throw new Error(
      response.jackpot.getCurrentJackpotForBrand.message || 'Failed to fetch current jackpot'
    )
  }
}

export const getCurrentJackpotForBrandUserSpecific = async () => {
  const { operatorId, brandId, currency, playerId, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_CURRENT_JACKPOT_FOR_BRAND_USER_SPECIFIC,
      variables: { operatorId, brandId, currency, playerId, gameCode },
    },
  })

  logger.info(MODULE, 'getCurrentJackpotForBrandUserSpecific Response', response)

  if (response.jackpot.getCurrentJackpotForBrandUserSpecific.success) {
    return response.jackpot.getCurrentJackpotForBrandUserSpecific.data
  } else {
    throw new Error(
      response.jackpot.getCurrentJackpotForBrandUserSpecific.message ||
        'Failed to fetch user-specific jackpot'
    )
  }
}

export const getUserAllTicketsForJackpot = async ({ jackpotId } = {}) => {
  const { playerId } = getGlobalParams()

  const response = await networkClient({
    request: { query: GET_USER_ALL_TICKETS_FOR_JACKPOT, variables: { jackpotId, playerId } },
  })

  logger.info(MODULE, 'getUserAllTicketsForJackpot Response', response)

  if (response.jackpot.getUserAllTicketsForJackpot.success) {
    return response.jackpot.getUserAllTicketsForJackpot.data
  } else {
    throw new Error(
      response.jackpot.getUserAllTicketsForJackpot.message || 'Failed to fetch user tickets'
    )
  }
}

export const getTopCurrentJackpotContributions = async () => {
  const { operatorId, brandId, currency, playerId } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_TOP_CURRENT_JACKPOT_CONTRIBUTIONS,
      variables: { operatorId, brandId, currency, playerId },
    },
  })

  logger.info(MODULE, 'getTopCurrentJackpotContributions Response', response)

  if (response.jackpot.getTopCurrentJackpotContributions.success) {
    return response.jackpot.getTopCurrentJackpotContributions.data
  } else {
    throw new Error(
      response.jackpot.getTopCurrentJackpotContributions.message ||
        'Failed to fetch top contributions'
    )
  }
}

export const getPrizeDistributionDetailsForJackpot = async ({ jackpotId } = {}) => {
  const response = await networkClient({
    request: { query: GET_PRIZE_DISTRIBUTION_DETAILS_FOR_JACKPOT, variables: { jackpotId } },
  })

  logger.info(MODULE, 'getPrizeDistributionDetailsForJackpot Response', response)

  if (response.jackpot.getPrizeDistributionDetailsForJackpot.success) {
    return response.jackpot.getPrizeDistributionDetailsForJackpot.data
  } else {
    throw new Error(
      response.jackpot.getPrizeDistributionDetailsForJackpot.message ||
        'Failed to fetch prize distribution'
    )
  }
}

export const getUserContributionsForJackpot = async ({ jackpotId } = {}) => {
  const { playerId } = getGlobalParams()

  const response = await networkClient({
    request: { query: GET_USER_CONTRIBUTIONS_FOR_JACKPOT, variables: { jackpotId, playerId } },
  })

  logger.info(MODULE, 'getUserContributionsForJackpot Response', response)

  if (response.jackpot.getUserContributionsForJackpot.success) {
    return response.jackpot.getUserContributionsForJackpot.data
  } else {
    throw new Error(
      response.jackpot.getUserContributionsForJackpot.message ||
        'Failed to fetch user contributions'
    )
  }
}

export const getUserJackpotHistory = async () => {
  const { operatorId, brandId, currency, playerId } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_USER_JACKPOT_HISTORY,
      variables: { operatorId, brandId, currency, playerId },
    },
  })

  logger.info(MODULE, 'getUserJackpotHistory Response', response)

  if (response.jackpot.getUserJackpotHistory.success) {
    return response.jackpot.getUserJackpotHistory.data
  } else {
    throw new Error(
      response.jackpot.getUserJackpotHistory.message || 'Failed to fetch jackpot history'
    )
  }
}

export const getUserJackpotHistoryResults = async ({ jackpotId } = {}) => {
  const { playerId } = getGlobalParams()

  const response = await networkClient({
    request: { query: GET_USER_JACKPOT_HISTORY_RESULTS, variables: { jackpotId, playerId } },
  })

  logger.info(MODULE, 'getUserJackpotHistoryResults Response', response)

  if (response.jackpot.getUserJackpotHistoryResults.success) {
    return response.jackpot.getUserJackpotHistoryResults.data
  } else {
    throw new Error(
      response.jackpot.getUserJackpotHistoryResults.message ||
        'Failed to fetch jackpot history results'
    )
  }
}
